// Format phone number as user types: 2155551234 → 215-555-1234
export const formatPhoneNumber = (value) => {
  // Remove all non-digit characters
  const digits = value.replace(/\D/g, '');
  
  // Limit to 10 digits
  const limited = digits.slice(0, 10);
  
  // Format based on length
  if (limited.length <= 3) {
    return limited;
  } else if (limited.length <= 6) {
    return `${limited.slice(0, 3)}-${limited.slice(3)}`;
  } else {
    return `${limited.slice(0, 3)}-${limited.slice(3, 6)}-${limited.slice(6)}`;
  }
};

// Format a numeric value as currency: 2500 → "$2,500.00"
export const formatCurrency = (value) => {
  const num = parseFloat(String(value || 0).replace(/[$,]/g, ''));
  if (isNaN(num)) return '$0.00';
  return '$' + num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

// Format a numeric value with commas: 12500 → "12,500"
export const formatNumber = (value) => {
  const num = parseFloat(String(value || 0).replace(/[$,]/g, ''));
  if (isNaN(num)) return '0';
  return num.toLocaleString('en-US');
};

// Format phone for display (handles already formatted or unformatted)
export const displayPhoneNumber = (value) => {
  if (!value) return '';
  
  // Remove all non-digit characters
  const digits = value.replace(/\D/g, '');
  
  // If it's already 10 digits, format it
  if (digits.length === 10) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  
  // Otherwise return original value (might already be formatted)
  return value;
};
